var Client = require('./lib/client')

function createClient (options) {
  return new Client(options)
}

module.exports = {
  createClient: createClient
}



//////////////////
// WEBPACK FOOTER
// ./~/youtube-finder/index.js
// module id = ALP4
// module chunks = 0